import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchInternalUser(parameters) {
  const response = await $.soap({
    body: {
      SearchInternalUser: {
        $xmlns: 'http://dla.mil/ems/bpm/user',
        Name: parameters.name,
        CrsRegion: parameters.crsRegion,
        EpcRegion: parameters.epcRegion,
        UserType: parameters.userType
      }
    },
    blueprintArrays: ['SearchInternalUserResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      users: [
        '$..old.rowset.row',
        {
          id: '$..ID',
          userName: '$..UserName',
          roles: '$..Roles',
          regionNames: '$..RegionNames',
          regionGroupNames: '$..RegionGroupNames'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.users;
}
